import { render, staticRenderFns } from "./SleepingHouseEditorModal.vue?vue&type=template&id=1dae371c&lang=pug&"
import script from "./SleepingHouseEditorModal.vue?vue&type=script&lang=js&"
export * from "./SleepingHouseEditorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports